import {Utility} from "@renta-apps/athenaeum-toolkit";
import {ApplicationContext, ch, IBasePage} from "@renta-apps/athenaeum-react-common";
import Dictionary from "typescript-collections/dist/lib/Dictionary";
import UserContext from "@/models/server/UserContext";

export enum DataStorageType {
    Session,

    Page,

    Route
}

class UserInteractionDataStorage {

    private readonly _data: Dictionary<string, any> = new Dictionary<string, any>();
    private _initialized: boolean = false;
    private _key: string | null = null;

    private get key(): string {
        if (this._key == null) {
            const context: ApplicationContext | null = ch.findContext();
            const applicationName: string = ((context) && (context.applicationName))
                ? context.applicationName
                : document.location.host;
            this._key = `$${applicationName}.${ch.getSessionId()}.userInteractionDataStorage`;
        }
        return this._key;
    }

    private get data(): Dictionary<string, any> {
        this.initialize();
        return this._data;
    }

    private initialize(): void {
        if (!this._initialized) {
            this._initialized = true;

            const json: string | null = window.localStorage.getItem(this.key);
            if (json) {
                const data = JSON.parse(json);
                const destination = this._data as any;
                destination.table = data.table;
                destination.nElements = data.nElements;
            }
        }
    }

    private save(): void {
        const json: string = JSON.stringify(this.data);
        window.localStorage.setItem(this.key, json);
    }

    private getKey(type: DataStorageType, id: string): string {
        const page: IBasePage | null = ch.findPage();
        return ((page == null) || (type == DataStorageType.Session))
            ? id
            : (type == DataStorageType.Route)
                ? `${page.routeName}:${page.routeIndex}:${page.routeId}:${id}`
                : `${page.routeName}:${id}`;
    }

    public setFilters(value: any, id: string = "filter", type: DataStorageType = DataStorageType.Page): void {
        let context: UserContext = ch.getContext() as UserContext;
        if (context.userSpecificFilters) {
            this.set(id, value, type);
        }
    }

    public set(id: string, value: any, type: DataStorageType = DataStorageType.Page): void {
        const key: string = this.getKey(type, id);
        this.data.setValue(key, value);
        this.save();
    }

    public getFilters(defaultValue: any | null = null, id: string = "filter", type: DataStorageType = DataStorageType.Page): any | null {
        let context: UserContext = ch.getContext() as UserContext;
        if (context.userSpecificFilters) {
            return this.get(id, defaultValue, type);
        }
        return defaultValue;
    }

    public get(id: string, defaultValue: any | null = null, type: DataStorageType = DataStorageType.Page): any | null {
        const key: string = this.getKey(type, id);
        return this.data.getValue(key) || defaultValue;
    }

    public restore(id: string, to: any, type: DataStorageType = DataStorageType.Page): any | null {
        const key: string = this.getKey(type, id);
        const value = this.data.getValue(key);
        if ((value != null) && (to != null)) {
            Utility.copyTo(value, to);
        }
        return to;
    }

    public async onAuthorize(): Promise<void> {
        this._initialized = false;
        this._key = null;
    }
}

export default new UserInteractionDataStorage();